import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'video-results',
    templateUrl: 'video-results.component.html',
    styleUrls: ['video-results.component.scss']
})
export class VideoResultsComponent {
    @Input() results = [];
    @Input() checkboxesEnabled = true;

    @Output() onHandleOpen = new EventEmitter();

    constructor() {
    }

    handleResultCheckbox(result) {
        result.checked = !result.checked;
    }

    handleTableRowClick(result) {
        result.collapsed = !result.collapsed;
    }

    handleOpen(result) {
        const item: any = {
            parrot_id: result.parrot_id,
            title: result.title,
            displayName: result.displayName,
            catalogState: result.catalog_state,
            original_country: result.original_country,
            original_language: result.original_language,
            start_date: result.start_date,
            release_year: result.release_year,
            imdb_id: result.imdb_id,
            wikibase_id: result.wikibase_id,
            contentType: result.contentType
        };
        this.onHandleOpen.emit(item);
    }

    formatCatalogState(catalogState) {
        return catalogState.split('_').map((item) => {
            return item[0].toUpperCase().concat(item.slice(1));
        }).join(' ');
    }
}



// WEBPACK FOOTER //
// ./src/app/youtube-video/video-results/video-results.component.ts